import { ConfirmModule } from './core/components/confirm/confirm.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import 'hammerjs';
import { SharedModule } from './core/modules/shared.module';
import { AppComponent } from './app.component';
import { FuseMainModule } from './main/main.module';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { FuseConfigService } from './core/services/config.service';
import { FuseNavigationService } from './core/components/navigation/navigation.service';
import { FusePortfolioModule } from './main/content/portfolio/portfolio.module';
import { TranslateModule } from '@ngx-translate/core';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsExtra from '@angular/common/locales/extra/es';
import { MapaService } from './main/components/mapa/mapa.service';
import { ConstantesService } from './core/constantes/constantes.service';
import { GeneralService } from './core/services/general.service';
import { ActivosOcultosService } from './core/services/activos-ocultos.service';
import { ConfirmService } from './core/components/confirm/confirm.service';
import { ComfirmComponent } from './core/components/confirm/confirm.component';
import { NotificacionesService } from './core/notificaciones/notificaciones.service';
import { LoginService } from './main/content/login/login.service';
import { SelectClientModalService } from './core/select-client-modal/select-client-modal.service';
import { ListaModalComponent } from './core/components/lista-modal/lista-modal.component';
import { ContactDialogComponent } from './main/contact-dialog/contact-dialog.component';
import { KpiDialogComponent } from './main/content/activos/components/kpis-tabla/kpi-dialog.component';
import { PowerBiDialogComponent } from './main/content/activos/components/powerbi-tabla/powerbi-dialog.component';

registerLocaleData(localeEs, 'es', localeEsExtra);

const appRoutes: Routes = [
    {
        path      : '**',
        redirectTo: 'login'
    },
    {
        path      : 'portfolio',
        redirectTo: 'portfolio'
    },
    {
        path        : 'activos',
        redirectTo: './main/content/activos/activos.module#ActivosModule'
    },
    {
        path        : 'login',
        redirectTo: './main/content/login/login.module#LoginModule'
    },
    {
        path        : 'forgot',
        redirectTo: './main/content/forgot-password/forgot-password.module#ForgotPasswordModule'
    },
    {
        path        : 'dashboard',
        loadChildren: './main/content/dashboard/dashboard.module#FuseDashboardModule'
    }
];


@NgModule({
    declarations: [
        AppComponent, KpiDialogComponent, ListaModalComponent, ContactDialogComponent, PowerBiDialogComponent
    ],
    imports     : [
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, {useHash: true, onSameUrlNavigation: 'reload'}),
        SharedModule,
        TranslateModule.forRoot(),
        FuseMainModule,
        FusePortfolioModule,
        ConfirmModule
    ],
    providers   : [
        FuseSplashScreenService,
        FuseConfigService,
        FuseNavigationService,
        MapaService,
        ConstantesService,
        GeneralService,
        ConfirmService,
        NotificacionesService,
        LoginService,
        SelectClientModalService,
        ActivosOcultosService
    ],
    bootstrap   : [
        AppComponent
    ],
    entryComponents: [KpiDialogComponent, ComfirmComponent, ContactDialogComponent, PowerBiDialogComponent],
    exports: [RouterModule]
})
export class AppModule
{
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts